import { Divider } from "@mui/material";
import dayjs from "dayjs";
import { useIntl } from "react-intl";

import { OrderLabel } from "@/features/bookings/components/OrderLabel";
import type {
  FindUserReservationsFlightReservation,
  FindUserReservationsHotelReservation,
} from "@/types/codegen";
import { formatCurrency } from "@/utils/currency";

type Props = {
  reservation:
    | FindUserReservationsFlightReservation
    | FindUserReservationsHotelReservation;
  onClick: () => void;
};

export const OrderCardWithoutReservation = ({
  reservation,
  onClick,
}: Props) => {
  const intl = useIntl();

  return (
    <button
      type="button"
      className="section-card flex w-full flex-col gap-4 rounded-3xl"
      onClick={onClick}
    >
      <div className="flex w-full justify-between">
        <span>
          {`${intl.formatMessage({ defaultMessage: "Booked at", description: "Label for the date and time the booking was made" })}: ${dayjs(reservation.createdAt).format("DD MMM, YYYY")}`}
        </span>

        <OrderLabel status={reservation.status} />
      </div>
      <Divider />
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span>{`${intl.formatMessage({ defaultMessage: "ID", description: "Label for the internal reservation ID in booking details" })}: ${reservation.id}`}</span>
        <div className="grow text-end">
          <strong>
            {formatCurrency(reservation.price, reservation.currency)}
          </strong>
        </div>
      </div>
    </button>
  );
};
